import * as React from "react";
const SvgCardIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M23 18a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-7h22v7ZM21 4a2 2 0 0 1 2 2v2H1V6a2 2 0 0 1 2-2h18Z" }));
export default SvgCardIcon;
